/* eslint-disable require-jsdoc */
import {
  EmailShareButton,
  EmailIcon,
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
} from "react-share";
import {Popover as BootstrapPop, OverlayTrigger, Alert} from 'react-bootstrap';
import React, { useState } from 'react';
import { getShareUrl } from "../../../../utils/url";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faFacebook, faTwitter} from '@fortawesome/free-brands-svg-icons';
import {faEnvelope, faSms} from "@fortawesome/free-solid-svg-icons";
import 'react-phone-number-input/style.css'
import PhoneInput, {isPossiblePhoneNumber} from 'react-phone-number-input'
import http from "../../services/http";
import { pApiBase } from "../../../../config";
import { isValid } from "../../../../utils/validate";


const socialMediaArray=[faFacebook, faTwitter, faEnvelope, faSms];

const types = ['event'];

function validTypes(type) {
return types.includes(type);
}

export default function PopUpShare(props) {
const [smsInputError, setSMSInputError] = useState(false);
const [show, setShow] = useState(false);
const shareUrl = getShareUrl(props.guid, props.lat, props.lon, props.type);
const [showPhoneNumBox, setShowPhoneNumBox] = useState(false);
const [phoneNumValue, setPhoneNumValue] = useState(undefined);

const checkProps = () => {
  if(!validTypes(props.type)) {
    const errorMessage = `Wrong type "${props.type}" passed to Share component`;
    console.error(errorMessage);
  }
}

checkProps();

const handleTrigger = () => {
  setShow(!show);
  setPhoneNumValue(undefined);
  setSMSInputError(false);
}

function Clipboard() {
  return (
  <div className="hearby-clipboard-share" 
       type="button" 
       onClick={() => {navigator.clipboard.writeText(shareUrl)} }>
     Copy link
  </div>
)};

const togglePhoneNumInputBox = () => {
  setShowPhoneNumBox(!showPhoneNumBox);
};   

const sendSMS = async () => {
  const destinationNumber = phoneNumValue;
  const sharedEventLink = shareUrl;

  if (isValid(destinationNumber) && isPossiblePhoneNumber(phoneNumValue) 
      && isValid(shareUrl) && !phoneNumValue.startsWith("+1900")
      && !phoneNumValue.startsWith("+1976")) {
    const query = `${pApiBase}/sms?destination_number=${destinationNumber}` 
    +`&shared_event_link=${sharedEventLink}`;
    await http.post(
      props.hearbyKey,
      query,
      true,
    );
    setSMSInputError(false)
    setShowPhoneNumBox(!showPhoneNumBox);
  }
  else {
    setSMSInputError(true);
  }
};

// const country = '';

const phoneNumInputBox = (
  <div>
    <PhoneInput
      className="hearby-share-sms-box"
      addInternationalOption={false}
      countries={["US","GB"]}
      defaultCountry="US"
      placeholder={`Enter phone number`}
      value={phoneNumValue}
      onChange={setPhoneNumValue}
      // error={phoneNumValue ? (isPossiblePhoneNumber(phoneNumValue) ? undefined : 'Invalid phone number') : 'Phone number required'}
    />
    <button className="hearby-share-sms-button" onClick={sendSMS}>Send Free SMS With Event Info</button>
    {smsInputError && 
    <div className = 'hearby-error-in-sms-input'>
      <Alert variant="danger">
        Invalid phone number. Country flag must be selected first and the number must be either in GB or US format.         
      </Alert>
    </div>}
  </div>
);

const popover = (
  <BootstrapPop className="popover-share">
        <BootstrapPop.Content>
        <div className="hearby-share-buttons">
          {showPhoneNumBox && phoneNumInputBox}
         <FacebookShareButton url={shareUrl} quote={'this is a sweet quote'} 
            hashtag={'#hearby'} >
            <span className="hearby-icon hearby-social-icon
              hearby-social-icon-facebook">
                <FontAwesomeIcon icon={socialMediaArray[0]} size="1x"/>
            </span>
            </FacebookShareButton>
            <TwitterShareButton url={shareUrl} title={'Hearby event title'}
             hashtags={['Hearby1','Hearby2']} via={'this is a really cool via string.'}
            >
            <span className="hearby-icon hearby-social-icon hearby-social-icon-twitter">
              <FontAwesomeIcon icon={socialMediaArray[1]} size="1x"/>
            </span>
            </TwitterShareButton>
            <EmailShareButton url={shareUrl} subject={'Hearby event subject'}
            body={'this is the body of the email'}>
            <span className="hearby-icon hearby-social-icon
              hearby-social-icon-email">
                <FontAwesomeIcon icon={socialMediaArray[2]} size="1x" />
            </span>  
            </EmailShareButton>
            <span className="hearby-icon hearby-social-icon hearby-social-icon-sms"
              onClick = {togglePhoneNumInputBox}>
              <FontAwesomeIcon icon={socialMediaArray[3]} size="1x" />
            </span> 
            <Clipboard />
         </div>
          </BootstrapPop.Content>
    </BootstrapPop> 
    );

return(
  <div className="hearby-share-popover-area">
  <OverlayTrigger trigger='click' placement="bottom" overlay={popover} 
    rootClose={true} onToggle={handleTrigger} 
    defaultShow={true}
    popperConfig={{strategy: 'fixed'}} >
     <div 
        className="hearby-share-popover-button" 
        type="button">Share event
     </div> 
  </OverlayTrigger> 
</div>

    );
}